<template>
  <section class="model_info__modal">
    <div class="setting-card">
      <div class="setting-card_header">
        <span class="setting-card_header_name">
          {{ `${device_fid} (${device_name})` }}
        </span>
      </div>

      <div class="setting-card_content">
        <div class="card">
          <div v-for="(item, key) in model_info"
               :key="key"
               class="setting-card_content_channels content-item" >
            <div class="left">
              <span class="title">
                {{ translate('device_models.'+key) }}
              </span>
            </div>
            <div class="right">
              <span class="title">
                {{ key === "has_wifi" || key === "has_poe_in" || key === "has_poe_out" ? item > 0 ? "+" : "-" : item}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center">
      <button
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </section>
</template>

<script>


export default {
  name: "ShowModelInfo",
  props: [
      "device_fid",
      "device_name"
  ],
  data () {
    return {
      model_info: null
    }
  },
  created () {
    this.get_model_info()
  },
  methods: {
    close_modal () {
      this.$emit('close')
    },
    get_model_info(){
      this.$http.v1.getDeviceModelInfo(this.device_fid,(response) => {
        this.model_info = response.data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .model_info__modal{
    .title{
      text-align: center;
      margin-top: 10px;
      text-transform: uppercase;
      span{
        display: block;
      }
    }
    .duration{
      text-align: center;
    }
    .setting-card {
      color: #252422;
      position: relative;
      border: 1px solid #ccc;
      min-height: 85px;
      background-color: #f8f8f8;
      &_header {
        font: 300 14px/20px "Roboto", Arial, sans-serif;
        text-transform: uppercase;
        color: #000;
        padding: 1rem 2rem;
        text-align: center;
        border-bottom: 1px solid #ccc;
        &_name{
          font-size: 18px;
        }
      }
      &_content {
        font: 300 12px/16px "Roboto", Arial, sans-serif;
        text-align: center;
        padding: 10px;
        .card{
          padding-bottom: 0;
        }
        .content-item{
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding: 5px;
          &:nth-child(2n+1) {
            background-color: #e2ecdc;
          }
          .left{
            width: 40%;
          }
          .right{
            width: 60%;
          }
          div{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 12px;
            height: 100%;
            span{
              text-overflow: ellipsis;
              vertical-align: center;
            }
          }
        }
      }
      &_footer {
        text-align: center;
        padding: 15px 0 5px;
        border-top: 1px solid #ccc;
      }
    }
    .text-center{
      padding-bottom: 10px;
    }
  }
</style>
